import { FC, useCallback, useEffect, useRef } from "react";
import { ImperativePanelHandle, Panel } from "react-resizable-panels";
import { useWillUnmount } from "rooks";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { explainWithAIModeSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAIModeSelector";
import { useLayoutConfigHook } from "@/components/layout/utils/hooks/useLayoutConfigHook";
import {
  resetExplainWithAI,
  setExplainWithAiMode,
} from "@/store/explain-with-ai/explainWithAiSlice";
import { ExplainWithAiPanelBody } from "@/components/common/explain-with-ai-drawer/components/body/ExplainWithAiPanelBody";

export const ExplainWithAiPanel: FC = () => {
  const { min, max, collapsedSize } = useLayoutConfigHook(0, 230, 800);
  const dispatch = useAppDispatch();
  const sideBarRef = useRef<ImperativePanelHandle>(null);
  const mode = useAppSelector(explainWithAIModeSelector);

  const onAfterCollapse = useCallback(() => {
    dispatch(setExplainWithAiMode(null));
  }, [dispatch]);

  const collapseHandler = useCallback(() => {
    sideBarRef.current?.collapse();
    dispatch(resetExplainWithAI());
  }, [dispatch]);

  useEffect(() => {
    if (mode) {
      sideBarRef.current?.expand();
    } else {
      sideBarRef.current?.collapse();
    }
  }, [mode, dispatch]);

  useWillUnmount(() => {
    dispatch(resetExplainWithAI());
  });

  return (
    <Panel
      order={2}
      collapsible
      minSize={min}
      maxSize={max}
      ref={sideBarRef}
      defaultSize={35}
      collapsedSize={collapsedSize}
      id="explain-with-ai-panel-in-dashbaord  "
      onCollapse={onAfterCollapse}
      style={{ overflowY: "auto", background: "white" }}
    >
      {mode && <ExplainWithAiPanelBody onClose={collapseHandler} />}
    </Panel>
  );
};
